import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { httpRequest } from '@calendly/http-tools'

import { monthSelector } from 'selectors'
import {
  fetchCalendar,
  clearCalendar
} from 'actions/calendar'
import { setCurrentUser } from 'actions/current_user'
import { useI18n } from 'locales'

import Header from './header'
import NotMeLink from './not_me_link'
import QuitLink from './quit_link'
import { Input, SubmitButton, Centered } from './styles'

export default ({ authenticationData, setAuthenticationData, closePopup }) => {
  const { i18n } = useI18n()
  const [errors, setErrors] = useState([])
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const month = useSelector((state) => monthSelector(state))
  const dispatch = useDispatch()

  async function submitForm() {
    if (!password) {
      setErrors([i18n.t('booking.templates.questions.errors.string.blank')])
      return null
    }

    setLoading(true)

    const [success, responseData] = await httpRequest({
      url: '/users/sessions',
      method: 'POST',
      data: {
        authenticity_token: authenticationData.authenticity_token,
        lang: i18n.locale,
        user: {
          email: authenticationData.email,
          password
        },
        flow: 'mutual_availability'
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (success) {
      i18n.locale = responseData.current_user.locale
      setLoading(false)
      dispatch(setCurrentUser(responseData.current_user))
      dispatch(clearCalendar())
      dispatch(fetchCalendar(month))
    } else {
      setLoading(false)
      setErrors([responseData.message])
    }

    return null
  }

  return (
    <form
      noValidate
      onSubmit={(e) => {
        e.preventDefault()
        submitForm()
      }}
    >
      <Header>{i18n.t('booking.mutual_availability.login.welcome_back', { email: authenticationData.email })}</Header>
      <NotMeLink onClick={() => setAuthenticationData(null)} />
      <Input
        label={i18n.t('booking.mutual_availability.login.password_label')}
        placeholder={i18n.t('booking.mutual_availability.login.password_placeholder')}
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onFocus={() => setErrors([])}
        error={errors?.[0]}
        autoComplete="current-password"
      />
      <SubmitButton loading={loading}>{i18n.t('booking.mutual_availability.signin_button')}</SubmitButton>
      <Centered>
        <QuitLink closePopup={closePopup} />
      </Centered>
    </form>
  )
}
